module.exports = __webpack_public_path__ + "static/media/Cluster_bulk_uploader.50e88d4c.xlsx";